import React, { useEffect, useState } from 'react'
import { Button, Form, message, Modal } from 'antd'
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc'
import arrayMove from 'array-move'
import {
  DragHandleWrapper,
  InstructionNote,
  ListWrapper,
  SortItem,
  SortModalFooter,
  SortModalWrapper,
  SortPositionModalGlobalStyle,
} from './SortPositionModalStyled'
import { HolderOutlined, InfoCircleOutlined } from '@ant-design/icons'
import positionStore from '../../../stores/positionStore'

const SortPositionodal = sortPositionModalProps => {
  const {
    isVisibleSortPositionModal,
    handleCancelSortPositionModal,
    positionList,
    onRefreshListPosition,
  } = sortPositionModalProps

  const [isLoading, setIsLoading] = useState(false)
  const [items, setItems] = useState(positionList)

  useEffect(() => {
    if (isVisibleSortPositionModal) {
      setItems(positionList)
    }
  }, [isVisibleSortPositionModal])

  const DragHandle = sortableHandle(() => (
    <DragHandleWrapper>
      <HolderOutlined />
    </DragHandleWrapper>
  ))

  const SortableItem = sortableElement(({ value }) => (
    <SortItem>
      <DragHandle />
      <span>{value}</span>
    </SortItem>
  ))

  const SortableContainer = sortableContainer(({ children }) => {
    return <ListWrapper>{children}</ListWrapper>
  })

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setItems(arrayMove(items, oldIndex, newIndex))
  }

  const save = async () => {
    try {
      setIsLoading(true)
      await positionStore.sort(items.map(item => item.code))

      onRefreshListPosition()

      message.success('Sắp xếp thứ tự chức danh thành công')

      handleCancelSortPositionModal()
    } catch (e) {
      console.log(e)
      message.error(e.vi || 'Có sự cố xảy ra')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      className="sort-position-modal"
      title={`Sắp xếp thứ tự hiển thị`}
      footer={null}
      closable={true}
      visible={isVisibleSortPositionModal}
      onCancel={handleCancelSortPositionModal}>
      <SortPositionModalGlobalStyle />
      <SortModalWrapper>
        <InstructionNote>
          <InfoCircleOutlined />
          <span>Kéo giữ biểu tượng để thay đổi thứ tự hiển thị chức danh</span>
        </InstructionNote>
        <Form layout={'vertical'}>
          <Form.Item style={{ marginBottom: 0 }}>
            <SortableContainer onSortEnd={onSortEnd} useDragHandle>
              {items.map((value, index) => (
                <SortableItem key={value.code} index={index} value={value.name} />
              ))}
            </SortableContainer>
          </Form.Item>

          <SortModalFooter>
            <Button
              className="btn-cancel"
              htmlType="button"
              onClick={handleCancelSortPositionModal}>
              Hủy
            </Button>
            <Button
              className="btn-submit"
              loading={isLoading}
              onClick={save}
              type={'primary'}>
              Cập nhật
            </Button>
          </SortModalFooter>
        </Form>
      </SortModalWrapper>
    </Modal>
  )
}

SortPositionodal.propTypes = {}

export default SortPositionodal
